import React from 'react'
import { Header } from '../../components'
import Hero from './components/Hero'
import Features from './components/Features'
import BusinessBrag from './components/BusinessBrag'
import ContactSection from './components/ContactSection'
import Testimonials from './components/Testimonials'

function WelcomePage() {
  return (
    <div className='welcome'>
        <Header />
        <Hero />
        <Features />
        <BusinessBrag />
        <ContactSection />
        <Testimonials />
        {/* <Footer /> */}
    </div>
  )
}

export default WelcomePage
